import { getFirestore, doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { app } from "../config";
import { isDemoMode } from "../../demo/isDemoMode";
import demoStore from "../../demo/demoStore";

const db = getFirestore(app);

// Function to get event details by eventId and associated registrations
const getEventDetails = async (eventID) => {
  try {
    if (isDemoMode) {
      // Demo mode: read from demoStore
      const eventDetails = demoStore.getDoc('events', eventID);
      if (!eventDetails) {
        return { success: false, message: "No such event found" };
      }

      // Get registrations for this event
      const allRegistrations = demoStore.getDocs('mpsEventRegistration', [
        { type: 'where', field: 'eventId', op: '==', value: eventID }
      ]);
      const registrations = allRegistrations.map(reg => ({
        id: reg.id,
        ...reg.data,
      }));

      return {
        success: true,
        data: {
          event: eventDetails,
          mpsRegistrations: registrations,
        },
      };
    }

    // Production: read from Firestore
    // Reference the document in the events collection with the provided eventId
    const docRef = doc(db, "events", eventID);
    const docSnap = await getDoc(docRef);

    let eventDetails = null;
    if (docSnap.exists()) {
      // Retrieve the event details
      eventDetails = docSnap.data();
    } else {
      return { success: false, message: "No such event found" };
    }

    // Query the mpsEventRegistration collection where eventId matches
    // This may fail for MPS users due to Firestore rules (they can only read their own registrations)
    let registrations = [];
    try {
      const registrationsRef = collection(db, "mpsEventRegistration");
      const registrationsQuery = query(registrationsRef, where("eventId", "==", eventID));
      const querySnapshot = await getDocs(registrationsQuery);

      registrations = querySnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data(),
      }));
    } catch (regError) {
      console.warn("Could not fetch registrations (permission denied for non-owner):", regError.message);
    }

    // Return the combined event details and registrations
    return {
      success: true,
      data: {
        event: eventDetails,
        mpsRegistrations: registrations,
      },
    };
  } catch (error) {
    console.error("Error retrieving event details: ", error);
    return { success: false, message: error.message };
  }
};

export { getEventDetails };